export default {
  "userDepositBonusAdmin.thead.index": "#序号",
  "userDepositBonusAdmin.thead.documentId": "DocumentId",
  "userDepositBonusAdmin.thead.bindSite": "绑定站点",
  "userDepositBonusAdmin.thead.levelValue": "等级",
  "userDepositBonusAdmin.thead.levelAmount": "晋级经验值要求",
  "userDepositBonusAdmin.thead.bonusValue": "晋级礼金",
  "userDepositBonusAdmin.thead.weeklyBonus": "每周返现",
  "userDepositBonusAdmin.thead.monthlyBonus": "每月返现",
  "userDepositBonusAdmin.thead.withdrawTimesLimit": "提现次数限制",
  "userDepositBonusAdmin.thead.withdrawAmountLimit": "提现金额限制",
  "userDepositBonusAdmin.thead.weeklyCashbackConf": "每周返现配置",
  "userDepositBonusAdmin.thead.monthlyCashbackConf": "每月返现配置",
  "userDepositBonusAdmin.thead.promotionCashbackConf": "晋级返现配置",
  "userDepositBonusAdmin.thead.cashbackAmountType": "奖励金类型",
  "userDepositBonusAdmin.thead.cashbackValue": "奖励金",
  "userDepositBonusAdmin.thead.cashbackWithdrawLimit": "返现金额提现限制",
  "userDepositBonusAdmin.thead.cashbackExpire": "奖励过期小时数",
  "userDepositBonusAdmin.thead.startTime": "奖励可领取小时数",
  "userDepositBonusAdmin.add": "新增",
  "userDepositBonusAdmin.edit": "编辑",
  "userDepositBonusAdmin.details": "详情",
  "userDepositBonusAdmin.delete": "删除",

  "userDepositBonusAdmin.thead.status": "状态",
  "userDepositBonusAdmin.thead.createdAt": "创建时间",
  "userDepositBonusAdmin.thead.updatedAt": "修改时间",
  "userDepositBonusAdmin.thead.action": "操作",

  // 存款红利特定字段
  "userDepositBonusAdmin.thead.id": "ID",
  "userDepositBonusAdmin.thead.bonusId": "优惠ID",
  "userDepositBonusAdmin.thead.bonusTitle": "优惠标题",
  "userDepositBonusAdmin.thead.sort": "排序",
  "userDepositBonusAdmin.thead.bonusDescItems": "优惠描述项",
  "userDepositBonusAdmin.thead.claimLimit": "领取限制",
  "userDepositBonusAdmin.thead.claimLimitReset": "领取限制重置",
  "userDepositBonusAdmin.thead.maximumDeposit": "最大存款",
  "userDepositBonusAdmin.thead.minimumDeposit": "最小存款",
  "userDepositBonusAdmin.thead.expire": "过期时间",
  "userDepositBonusAdmin.thead.active": "激活状态",
  "userDepositBonusAdmin.thead.bonusDescTitle": "优惠描述标题",
  "userDepositBonusAdmin.thead.currency": "货币",
  "userDepositBonusAdmin.thead.bonusAmounts": "优惠金额",
  "userDepositBonusAdmin.thead.returnDays": "返还天数",
  "userDepositBonusAdmin.thead.depositType": "存款类型",
  "userDepositBonusAdmin.thead.multTimesDepositAmounts": "多次存款金额",
  "userDepositBonusAdmin.thead.startAt": "开始时间",
  "userDepositBonusAdmin.thead.bonusBg": "优惠背景",
  "userDepositBonusAdmin.thead.singleQueue": "单一队列",
  "userDepositBonusAdmin.thead.amountRemarkTitle": "金额备注标题",
  "userDepositBonusAdmin.thead.setDefaultData": "设置默认数据",
  "userDepositBonusAdmin.thead.channels": "渠道",
  "userDepositBonusAdmin.thead.createdBy": "创建人",
  "userDepositBonusAdmin.thead.updatedBy": "修改人",
  "userDepositBonusAdmin.thead.bonusType": "奖励类型",

  // 奖金金额组成字段
  "userDepositBonusAdmin.thead.displayAmount": "显示金额",
  "userDepositBonusAdmin.thead.amount": "金额",
  "userDepositBonusAdmin.thead.cumulativeAmount": "累计金额",
  "userDepositBonusAdmin.thead.bonus": "奖金比例",
  "userDepositBonusAdmin.thead.bonus2": "奖金金额",
  "userDepositBonusAdmin.thead.rollover": "流水倍数",
  "userDepositBonusAdmin.thead.setDefaultCheckedAmount": "设置默认选中金额",
  "userDepositBonusAdmin.thead.bonusWay": "奖金方式",
  "userDepositBonusAdmin.thead.principalRollover": "本金流水倍数",
  "userDepositBonusAdmin.thead.freeSpinId": "免费旋转ID",
  "userDepositBonusAdmin.thead.freeSpinRounds": "免费旋转轮数",
  "userDepositBonusAdmin.thead.fixed": "固定金额",
  "userDepositBonusAdmin.thead.percentage": "百分比",
  "userDepositBonusAdmin.thead.random": "随机金额",
  "userDepositBonusAdmin.thead.proportion": "比例金额",
  "userDepositBonusAdmin.thead.isTimeLimit": "是否限时",
  "userDepositBonusAdmin.thead.specifiedTime": "指定时间",
  "userDepositBonusAdmin.thead.selectDayOfWeek": "选择周期",
  "userDepositBonusAdmin.thead.selectDay": "选择日期",
  "userDepositBonusAdmin.thead.getBonusType": "领取次数",
  "userDepositBonusAdmin.thead.numberOfRecharges": "充值次数",
  "userDepositBonusAdmin.thead.EveryDay": "每天",
  "userDepositBonusAdmin.thead.Null": "无",

  // 存款红利配置字段
  "userDepositBonusAdmin.thead.completeTimes": "完成次数",
  "userDepositBonusAdmin.thead.titleText": "标题文本",

  // 奖励描述项目字段
  "userDepositBonusAdmin.thead.descText": "描述文本",
  "userDepositBonusAdmin.thead.rightValueText": "右侧值文本",

  // 模态框和删除确认文本
  "userDepositBonusAdmin.modal.title": "标题",
  "userDepositBonusAdmin.delete.confirm.title": "删除配置",
  "userDepositBonusAdmin.delete.confirm.content": "请确定是否要删除这个配置?",
  "userDepositBonusAdmin.delete.confirm.okText": "确定",
  "userDepositBonusAdmin.delete.confirm.cancelText": "取消",
  "userDepositBonusAdmin.active.confirm.title": "激活配置",
  "userDepositBonusAdmin.active.confirm.content": "请确定是否要激活这个配置?",
  "userDepositBonusAdmin.active.confirm.okText": "确定",
  "userDepositBonusAdmin.deactive.confirm.title": "停用配置",
  "userDepositBonusAdmin.deactive.confirm.content": "请确定是否要停用这个配置?",
  "userDepositBonusAdmin.deactive.confirm.okText": "确定",
  "userDepositBonusAdmin.deactive.confirm.cancelText": "取消",

   //首笔存款损失返还
  "userDepositBonusAdmin.thead.rewardConfig": "奖励配置",
  "userDepositBonusAdmin.thead.lossRatio": "亏损比例(%)",
  "userDepositBonusAdmin.thead.rewardRatio": "返奖比例(%)",
  "userDepositBonusAdmin.thead.isDoubleReward": "奖励加倍",
  "userDepositBonusAdmin.thead.doubleType": "加倍方式",
  "userDepositBonusAdmin.thead.doubleValue": "加倍倍数",
  "userDepositBonusAdmin.thead.depositAmounts": "充值金额",
  "userDepositBonusAdmin.thead.doubleRollover": "加倍稽核流水倍数",
};
